// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__usIvO","addWidgetButton":"Header_addWidgetButton__325Pg","dashboardTabs":"Header_dashboardTabs__25Bt5","active":"Header_active__t79s7"};